import BaseConfigApi from "./BaseConfigApi";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import MediaRequestResource from "common/resources/Project/Config/Media/MediaRequestResource";
import { createFormData } from "utils/FormData";
import { EMediaKind } from "common/enums/Project/Config/Media/EMediaKind";

export default class MediaApi extends BaseConfigApi {
	protected override getBaseUrl(params: Record<string, string>): string {
		return `${super.getBaseUrl(params)}/medias`;
	}

	public async getByProjectId(projectId: string): Promise<MediaResponseResource[]> {
		return this.getRequest<MediaResponseResource[]>(this.getBaseUrl({ projectId })).then((response) => MediaResponseResource.hydrateArray(response));
	}

	public async getById(projectId: string, mediaId: string): Promise<MediaResponseResource> {
		return this.getRequest<MediaResponseResource>(`${this.getBaseUrl({ projectId })}/${mediaId}`).then((response) => MediaResponseResource.hydrate(response));
	}

	public async downloadFile(projectId: string, mediaId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId })}/${mediaId}/file`);
	}

	public async downloadPreviewImage(projectId: string, mediaId: string): Promise<Blob> {
		return this.getBlobRequest(`${this.getBaseUrl({ projectId })}/${mediaId}/preview-image`);
	}

	public async create(projectId: string, data: MediaRequestResource, file?: File): Promise<MediaResponseResource> {
		const formData = createFormData(data);
		if (file) {
			const keyFile = data.kind === EMediaKind.IMAGE ? "file" : "previewImage";
			formData.append(keyFile, file);
		}
		return this.postRequestFormdata<MediaResponseResource>(this.getBaseUrl({ projectId }), formData).then((response) => MediaResponseResource.hydrate(response));
	}

	public async update(projectId: string, mediaId: string, data: MediaRequestResource, file?: File): Promise<MediaResponseResource> {
		const formData = createFormData(data);
		if (file) {
			const keyFile = data.kind === EMediaKind.IMAGE ? "file" : "previewImage";
			formData.append(keyFile, file);
		}
		return this.putRequestFormdata<MediaResponseResource>(`${this.getBaseUrl({ projectId })}/${mediaId}`, formData).then((response) => MediaResponseResource.hydrate(response));
	}

	public async delete(projectId: string, mediaId: string): Promise<void> {
		return this.deleteRequest<void>(`${this.getBaseUrl({ projectId })}/${mediaId}`);
	}

	public async getIframe(projectId: string, mediaId: string): Promise<{ iframe: string | null }> {
		return this.getRequest<{ iframe: string | null }>(`${this.getBaseUrl({ projectId })}/${mediaId}/iframe`);
	}
}
